import { useState, useEffect } from 'react'

// Returns a MM:SS string that counts up while the game is running.
// Freezes at the correct value once endTime is set.
export function useTimer(startTime: number | null, endTime: number | null): string {
  const [now, setNow] = useState(() => Date.now())
  const running = startTime !== null && endTime === null

  useEffect(() => {
    if (!running) return
    const id = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(id)
  }, [running])

  const snapshot = endTime ?? (startTime ? now : 0)
  const s = Math.floor((startTime ? snapshot - startTime : 0) / 1000)
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}
